import { encodeParams, getCurrentTime } from '../../utils/utils';
function getBaseHost() {
  return /\.wixpress\.com/i.test(document.location.host) || /local\./i.test(document.location.host) ? '/images/43.gif?' : 'https://frog.wix.com';
}
export function sendBi(url, data) {
  let biImage = document.createElement('img');
  biImage.setAttribute('src', `${getBaseHost() + url}?${encodeParams(data)}&_=${getCurrentTime()}`);
  biImage = null;
}